'use strict';

// Localisations
// ============
module.exports = {
  en: {
    title: 'Messages',
    groupmembers: 'Members:',
    nomessages: 'There are no messages in this group yet.  The first one will be a question from FoeFace.  Watch this space.',
    nopostmessage: 'Posting is not available while waiting for everyone\'s initial response or immediately before a new topic is posted. ',
    send: 'Post',
    backbutton: 'Previous',
    forwardbutton: 'Next',
    ponder: 'Pondering',
    agree: 'Agree',
    disagree: 'Disagree',
    noreactions: 'no reactions',
    replyingto: 'Replying to:',
    specialmessage: 'You can react and reply to posts by clicking on the individual post\'s user icon.  Choose between the following reactions:',
    reply: 'Reply'
  },
  es: {
    title: 'Messages',
    groupmembers: 'Members:',
    nomessages: 'There are no messages in this group yet.  The first one will be a question from FoeFace.  Watch this space.',
    nopostmessage: 'Posting is not available while waiting for everyone\'s initial response or immediately before a new topic is posted. ',
    send: 'Post',
    backbutton: 'Previous',
    forwardbutton: 'Next',
    ponder: 'Pondering',
    agree: 'Agree',
    disagree: 'Disagree',
    noreactions: 'no reactions',
    replyingto: 'Replying to:',
    specialmessage: 'You can react and reply to posts by clicking on the individual post\'s user icon.  Choose between the following reactions:',
    reply: 'Reply'
  },
  fr: {

  },
  de: {

  }
};



// WEBPACK FOOTER //
// ./client/app/messages/messages.localisations.js